import React from 'react';
import './LegalPages.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1 className="legal-title">Privacy Policy</h1>
        
        <div className="legal-meta">
          <p><strong>Effective Date:</strong> June 1, 2025</p>
          <p><strong>Owner:</strong> Cult Camo LLC</p>
        </div>

        <div className="legal-section">
          <h2>1. Information Collected</h2>
          <p>I may collect:</p>
          <ul>
            <li>Contact information (e.g., email if provided)</li>
            <li>Uploaded photos and associated metadata</li>
            <li>IP address, device type, and browser data</li>
            <li>Anonymous usage statistics via analytics tools</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>2. Use of Information</h2>
          <p>Your data may be used to:</p>
          <ul>
            <li>Generate camouflage patterns</li>
            <li>Improve platform performance and design</li>
            <li>Communicate with users (if opted in)</li>
            <li>Promote the Site and content, including commercial reuse of submissions</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. Submissions and Intellectual Property</h2>
          <p>By uploading any content (photo, description, etc.), you agree:</p>
          <ul>
            <li>That I may <strong>use, modify, display, share, sell, or distribute</strong> the content freely for <strong>any purpose</strong>, including commercial.</li>
            <li>That all <strong>camouflage patterns created using or inspired by your input</strong> are the sole property of Cult Camo LLC.</li>
            <li>That you waive any rights to attribution, compensation, or control over the use of your submission.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. Data Security and Disclaimer</h2>
          <p>I take reasonable precautions to protect your data. However:</p>
          <blockquote>
            I make <strong>no guarantees</strong> about the security of submitted data, and I am <strong>not responsible</strong> for any unauthorized access, data breach, or data loss to the fullest extent allowed by law.
          </blockquote>
        </div>

        <div className="legal-section">
          <h2>5. Third-Party Services</h2>
          <p>
            This Site may use third-party tools (e.g., analytics, image processing, cloud storage) that operate under their own privacy policies. I do not control how these third parties handle your data.
          </p>
        </div>

        <div className="legal-section">
          <h2>6. Modifications</h2>
          <p>
            I may update this Privacy Policy at any time. Continued use of the Site constitutes acceptance of the latest version.
          </p>
        </div>

        <div className="legal-footer">
          <p>Last updated: June 1, 2025</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage; 